// Translations FR / EN / UA for EKOBIOTEK
export const translations = {
  fr: {
    nav: {
      about: "À propos",
      products: "Produits",
      process: "Production",
      quality: "Qualité",
      export: "Export",
      contact: "Contact",
      cta: "Demander un devis",
    },
    hero: {
      overline: "Depuis 2003 · Kherson · Ukraine",
      title1: "L'or liquide",
      title2: "des champs ukrainiens",
      subtitle:
        "EKOBIOTEK-UKRAINA cultive, presse et raffine l'huile de tournesol et les huiles végétales avec une exigence inflexible — du grain à la bouteille.",
      cta1: "Découvrir nos huiles",
      cta2: "Demander un devis",
      stat1: "Années d'expertise",
      stat2: "Collaborateurs",
      stat3: "Pays d'export",
    },
    about: {
      overline: "Notre histoire",
      title: "Une maison ukrainienne, dédiée à l'excellence",
      p1: "Fondée en 2003 à Kherson, EKOBIOTEK-UKRAINA SARL fabrique des huiles brutes et raffinées de tournesol ainsi qu'une gamme étendue d'huiles végétales destinées aux marchés alimentaires, pharmaceutiques et industriels.",
      p2: "Nos 90 collaborateurs perpétuent un savoir-faire né dans les terres noires d'Ukraine — réputées comme les plus fertiles d'Europe pour la culture du tournesol.",
      pillar1: { t: "Origine garantie", d: "Tournesol cultivé exclusivement en Ukraine, traçabilité grain par grain." },
      pillar2: { t: "Raffinage premium", d: "Procédé multi-étapes pour une huile claire, neutre et stable à la cuisson." },
      pillar3: { t: "Standard international", d: "Conditionnement export, conformité réglementaire UE et Asie." },
    },
    products: {
      overline: "Notre gamme",
      title: "Quatre huiles, une signature",
      subtitle: "Une expertise pure, du pressoir à votre table — ou à votre chaîne de production.",
      list: [
        {
          slug: "huile-tournesol-raffinee",
          name: "Huile de tournesol raffinée",
          tag: "Premium",
          desc:
            "Désodorisée, neutre, idéale pour la friture, l'agroalimentaire et l'embouteillage marque privée.",
          spec: "Acidité < 0,1% · Point de fumée 230°C",
          fullDesc:
            "Notre huile de tournesol raffinée est obtenue par un procédé multi-étapes : démucilagination, neutralisation, blanchiment et désodorisation. Le résultat : une huile parfaitement claire, neutre de goût, stable à haute température, idéale pour l'industrie agroalimentaire et la marque distributeur.",
          applications: [
            "Friture industrielle et domestique",
            "Production de mayonnaise, sauces, margarine",
            "Embouteillage sous marque privée",
            "Conserves et plats préparés",
          ],
          specs: [
            { k: "Acidité libre", v: "< 0,1% (oléique)" },
            { k: "Point de fumée", v: "230°C" },
            { k: "Indice de peroxyde", v: "< 2 meq O2/kg" },
            { k: "Humidité", v: "< 0,1%" },
            { k: "Couleur (Lovibond)", v: "≤ 1,5 R" },
            { k: "Durée de conservation", v: "12 mois" },
          ],
          packaging: [
            "Bouteilles PET 1 L / 3 L / 5 L",
            "Fûts 200 L",
            "IBC 1000 L",
            "Flexitank 20 000 – 24 000 L",
          ],
        },
        {
          slug: "huile-tournesol-brute",
          name: "Huile de tournesol brute",
          tag: "Pressée à froid",
          desc:
            "Saveur intense de graine, riche en vitamine E, parfaite pour assaisonnements et usage industriel.",
          spec: "Pression mécanique · Filtration douce",
          fullDesc:
            "Extraite par pression mécanique puis filtration douce, notre huile brute conserve tout l'arôme caractéristique de la graine de tournesol et sa richesse naturelle en vitamine E et phytostérols. Prisée des industries cosmétique, pharmaceutique et des professionnels de la gastronomie.",
          applications: [
            "Assaisonnements et finitions culinaires",
            "Matière première pour raffinerie",
            "Cosmétique et soins de la peau",
            "Biodiesel et usage industriel",
          ],
          specs: [
            { k: "Acidité libre", v: "1 – 2%" },
            { k: "Indice d'iode", v: "118 – 141" },
            { k: "Vitamine E", v: "40 – 60 mg/100g" },
            { k: "Humidité", v: "< 0,2%" },
            { k: "Durée de conservation", v: "6 mois" },
          ],
          packaging: [
            "Fûts 200 L",
            "IBC 1000 L",
            "Citerne / flexitank",
          ],
        },
        {
          slug: "huiles-vegetales-melangees",
          name: "Huiles végétales mélangées",
          tag: "Sur-mesure",
          desc:
            "Mélanges techniques selon cahier des charges : tournesol, colza, soja, maïs.",
          spec: "Personnalisation acide gras",
          fullDesc:
            "Nous formulons des mélanges d'huiles végétales sur-mesure : ratios oméga-3/6 ajustés, point de fumée optimisé, profil organoleptique personnalisé. Production sous accord de confidentialité et cahier des charges client.",
          applications: [
            "Formulations de cuisine professionnelle",
            "Nutrition sportive et enrichissement",
            "Industrie agroalimentaire (biscuiterie, plats cuisinés)",
            "Produits infantiles (sur validation)",
          ],
          specs: [
            { k: "Base", v: "Tournesol, colza, soja, maïs" },
            { k: "Profil acide gras", v: "Personnalisé" },
            { k: "Point de fumée", v: "200 – 240°C" },
            { k: "Additifs", v: "Vitamines A/D/E optionnels" },
          ],
          packaging: [
            "Bouteilles PET personnalisables",
            "Fûts 200 L",
            "IBC & flexitank",
          ],
        },
        {
          slug: "tourteaux-sous-produits",
          name: "Tourteaux & sous-produits",
          tag: "Circulaire",
          desc:
            "Tourteaux protéinés pour alimentation animale, valorisation complète de la graine.",
          spec: "32-38% protéines",
          fullDesc:
            "Les tourteaux de tournesol issus de notre pressoir constituent une source protéique de premier choix pour l'alimentation animale : bovins, porcs, volailles, aquaculture. Valorisation à 100% de la graine conforme à notre engagement zéro déchet.",
          applications: [
            "Alimentation bovine et laitière",
            "Élevage porcin et avicole",
            "Aquaculture",
            "Biogaz et énergie circulaire",
          ],
          specs: [
            { k: "Protéines brutes", v: "32 – 38%" },
            { k: "Matière grasse résiduelle", v: "1 – 2%" },
            { k: "Fibre brute", v: "18 – 22%" },
            { k: "Humidité", v: "< 11%" },
          ],
          packaging: [
            "Vrac (camion, train)",
            "Big bags 500 – 1000 kg",
            "Sacs 50 kg",
          ],
        },
      ],
      explore: "Voir la fiche",
      backToProducts: "← Retour aux produits",
      applicationsTitle: "Applications",
      specsTitle: "Spécifications techniques",
      packagingTitle: "Conditionnement",
      contactCta: "Demander un devis pour ce produit",
    },
    process: {
      overline: "Du champ à la bouteille",
      title: "Quatre étapes, zéro compromis",
      steps: [
        { n: "01", t: "Récolte", d: "Graines de tournesol issues des champs de la région de Kherson, sélectionnées à la moisson." },
        { n: "02", t: "Pressage", d: "Extraction par pression mécanique puis solvant pour un rendement optimal et une huile pure." },
        { n: "03", t: "Raffinage", d: "Démucilagination, neutralisation, blanchiment et désodorisation : chaque étape contrôlée en laboratoire." },
        { n: "04", t: "Embouteillage", d: "Conditionnement en bouteilles PET, fûts de 200 L, conteneurs flexitank pour l'export." },
      ],
    },
    quality: {
      overline: "Qualité & conformité",
      title: "Des standards qui ne cèdent jamais",
      subtitle: "Chaque lot est analysé. Chaque expédition est tracée. Chaque client mérite la même rigueur.",
      points: [
        "ISO 22000 — Sécurité des denrées alimentaires",
        "HACCP — Analyse des dangers et points critiques",
        "GMP+ — Bonnes pratiques de fabrication",
        "Halal & Kosher — Sur demande",
        "Non-OGM — Certifié",
        "Contrôle laboratoire interne",
      ],
    },
    exportSec: {
      overline: "Présence internationale",
      title: "L'huile de Kherson, exportée dans le monde",
      p:
        "Notre logistique multimodale — flexitanks, fûts ISO, bouteilles palettisées — permet une livraison fiable depuis les ports ukrainiens et roumains vers l'Europe, le Moyen-Orient, l'Afrique du Nord et l'Asie.",
      stats: [
        { v: "20+", l: "Pays partenaires" },
        { v: "50 000T", l: "Capacité annuelle" },
        { v: "24/48h", l: "Réponse devis" },
        { v: "100%", l: "Origine Ukraine" },
      ],
    },
    contact: {
      overline: "Contactez-nous",
      title: "Un projet ? Un volume à expédier ?",
      subtitle: "Notre équipe export répond sous 24-48h ouvrées, en français, anglais et ukrainien.",
      form: {
        name: "Nom complet",
        email: "Email professionnel",
        phone: "Téléphone",
        company: "Entreprise",
        product: "Produit d'intérêt",
        message: "Votre message",
        submit: "Envoyer la demande",
        sending: "Envoi en cours...",
        success: "Merci ! Votre message a bien été envoyé.",
        error: "Une erreur est survenue. Veuillez réessayer.",
        productPlaceholder: "Sélectionnez un produit",
      },
      info: {
        addressLabel: "Adresse",
        address: "73000, Kherson, vul. Raketna, 110a, Ukraine",
        phoneLabel: "Téléphones",
        emailLabel: "Email",
        scheduleLabel: "Horaires",
        schedule: "Lun – Ven · 09h00 – 18h00",
      },
    },
    footer: {
      tagline: "Producteur d'huile de tournesol & d'huiles végétales depuis 2003",
      rights: "Tous droits réservés.",
      legal: "Mentions légales",
      edrpou: "EDRPOU 32125693",
    },
    video: {
      overline: "L'usine en mouvement",
      title: "Découvrez notre savoir-faire en images",
      subtitle:
        "De la graine à la bouteille — plongez dans le quotidien d'EKOBIOTEK : nos lignes de production, nos équipes et l'exigence qui nous anime.",
      watchOnFacebook: "Voir sur Facebook",
      unmuteHint: "Activer le son",
      playingLabel: "Lecture en cours",
    },
  },

  en: {
    nav: {
      about: "About",
      products: "Products",
      process: "Process",
      quality: "Quality",
      export: "Export",
      contact: "Contact",
      cta: "Request a quote",
    },
    hero: {
      overline: "Since 2003 · Kherson · Ukraine",
      title1: "Liquid gold",
      title2: "from Ukrainian fields",
      subtitle:
        "EKOBIOTEK-UKRAINA grows, presses and refines sunflower and vegetable oils with uncompromising standards — from seed to bottle.",
      cta1: "Discover our oils",
      cta2: "Request a quote",
      stat1: "Years of expertise",
      stat2: "Team members",
      stat3: "Export markets",
    },
    about: {
      overline: "Our story",
      title: "A Ukrainian house devoted to excellence",
      p1: "Founded in 2003 in Kherson, EKOBIOTEK-UKRAINA, LLC produces crude and refined sunflower oils as well as a wide range of vegetable oils for the food, pharmaceutical and industrial markets.",
      p2: "Our 90 employees uphold a craft rooted in Ukraine's black soils — recognised as the richest in Europe for sunflower farming.",
      pillar1: { t: "Verified origin", d: "Sunflower exclusively grown in Ukraine, traceable seed by seed." },
      pillar2: { t: "Premium refining", d: "Multi-stage process for clear, neutral, stable oil." },
      pillar3: { t: "International standard", d: "Export-ready packaging, EU & Asia compliance." },
    },
    products: {
      overline: "Our range",
      title: "Four oils, one signature",
      subtitle: "A pure craft, from press to your table — or to your production line.",
      list: [
        {
          slug: "refined-sunflower-oil",
          name: "Refined sunflower oil",
          tag: "Premium",
          desc: "Deodorised, neutral, ideal for frying, food industry and private-label bottling.",
          spec: "Acidity < 0.1% · Smoke point 230°C",
          fullDesc:
            "Our refined sunflower oil is produced through a multi-stage process: degumming, neutralisation, bleaching and deodorisation. The result is a perfectly clear, neutral-tasting oil, stable at high temperatures, ideal for food industry and private-label bottling.",
          applications: [
            "Industrial and domestic frying",
            "Mayonnaise, sauces, margarine production",
            "Private-label bottling",
            "Canned food and ready meals",
          ],
          specs: [
            { k: "Free acidity", v: "< 0.1% (oleic)" },
            { k: "Smoke point", v: "230°C" },
            { k: "Peroxide value", v: "< 2 meq O2/kg" },
            { k: "Moisture", v: "< 0.1%" },
            { k: "Colour (Lovibond)", v: "≤ 1.5 R" },
            { k: "Shelf life", v: "12 months" },
          ],
          packaging: [
            "PET bottles 1 L / 3 L / 5 L",
            "200 L drums",
            "1000 L IBC",
            "Flexitank 20,000 – 24,000 L",
          ],
        },
        {
          slug: "crude-sunflower-oil",
          name: "Crude sunflower oil",
          tag: "Cold pressed",
          desc: "Intense seed flavour, rich in vitamin E, perfect for dressings and industrial use.",
          spec: "Mechanical pressing · Light filtration",
          fullDesc:
            "Extracted by mechanical pressing followed by light filtration, our crude oil preserves the characteristic aroma of sunflower seeds and their natural richness in vitamin E and phytosterols. A favourite of cosmetic, pharmaceutical and gastronomic industries.",
          applications: [
            "Culinary dressings and finishing",
            "Raw material for refineries",
            "Cosmetics and skincare",
            "Biodiesel and industrial use",
          ],
          specs: [
            { k: "Free acidity", v: "1 – 2%" },
            { k: "Iodine value", v: "118 – 141" },
            { k: "Vitamin E", v: "40 – 60 mg/100g" },
            { k: "Moisture", v: "< 0.2%" },
            { k: "Shelf life", v: "6 months" },
          ],
          packaging: ["200 L drums", "1000 L IBC", "Tanker / flexitank"],
        },
        {
          slug: "blended-vegetable-oils",
          name: "Blended vegetable oils",
          tag: "Tailor-made",
          desc: "Technical blends to specification: sunflower, rapeseed, soy, corn.",
          spec: "Customisable fatty acid profile",
          fullDesc:
            "We formulate custom vegetable oil blends: balanced omega-3/6 ratios, optimised smoke point, personalised organoleptic profile. Produced under NDA and client specification.",
          applications: [
            "Professional kitchen formulations",
            "Sports nutrition and fortification",
            "Food industry (bakery, ready meals)",
            "Infant products (on validation)",
          ],
          specs: [
            { k: "Base oils", v: "Sunflower, rapeseed, soy, corn" },
            { k: "Fatty acid profile", v: "Customisable" },
            { k: "Smoke point", v: "200 – 240°C" },
            { k: "Additives", v: "Optional vitamins A/D/E" },
          ],
          packaging: [
            "Customisable PET bottles",
            "200 L drums",
            "IBC & flexitank",
          ],
        },
        {
          slug: "meal-by-products",
          name: "Meal & by-products",
          tag: "Circular",
          desc: "Protein meal for animal feed, full seed valorisation.",
          spec: "32-38% protein",
          fullDesc:
            "Sunflower meal from our press is a premium protein source for animal feed: cattle, pigs, poultry, aquaculture. 100% seed valorisation in line with our zero-waste commitment.",
          applications: [
            "Cattle and dairy feed",
            "Pig and poultry farming",
            "Aquaculture",
            "Biogas and circular energy",
          ],
          specs: [
            { k: "Crude protein", v: "32 – 38%" },
            { k: "Residual fat", v: "1 – 2%" },
            { k: "Crude fibre", v: "18 – 22%" },
            { k: "Moisture", v: "< 11%" },
          ],
          packaging: [
            "Bulk (truck, rail)",
            "Big bags 500 – 1000 kg",
            "50 kg bags",
          ],
        },
      ],
      explore: "View spec sheet",
      backToProducts: "← Back to products",
      applicationsTitle: "Applications",
      specsTitle: "Technical specifications",
      packagingTitle: "Packaging",
      contactCta: "Request a quote for this product",
    },
    process: {
      overline: "From field to bottle",
      title: "Four stages, zero compromise",
      steps: [
        { n: "01", t: "Harvest", d: "Sunflower seeds from Kherson region fields, selected at harvest." },
        { n: "02", t: "Pressing", d: "Mechanical pressing then solvent extraction for optimal yield and pure oil." },
        { n: "03", t: "Refining", d: "Degumming, neutralisation, bleaching and deodorisation — laboratory-controlled at every step." },
        { n: "04", t: "Bottling", d: "PET bottles, 200 L drums, flexitank containers for export." },
      ],
    },
    quality: {
      overline: "Quality & compliance",
      title: "Standards that never bend",
      subtitle: "Every batch tested. Every shipment traced. Every client deserves the same rigour.",
      points: [
        "ISO 22000 — Food safety management",
        "HACCP — Hazard analysis & critical control",
        "GMP+ — Good manufacturing practice",
        "Halal & Kosher — On request",
        "Non-GMO — Certified",
        "Internal laboratory control",
      ],
    },
    exportSec: {
      overline: "International presence",
      title: "Kherson oil, shipped worldwide",
      p:
        "Our multimodal logistics — flexitanks, ISO drums, palletised bottles — deliver reliably from Ukrainian and Romanian ports to Europe, the Middle East, North Africa and Asia.",
      stats: [
        { v: "20+", l: "Partner countries" },
        { v: "50,000T", l: "Annual capacity" },
        { v: "24/48h", l: "Quote response" },
        { v: "100%", l: "Ukraine origin" },
      ],
    },
    contact: {
      overline: "Get in touch",
      title: "A project? A volume to ship?",
      subtitle: "Our export team replies within 24-48 business hours in French, English and Ukrainian.",
      form: {
        name: "Full name",
        email: "Business email",
        phone: "Phone",
        company: "Company",
        product: "Product of interest",
        message: "Your message",
        submit: "Send request",
        sending: "Sending...",
        success: "Thank you! Your message has been sent.",
        error: "Something went wrong. Please try again.",
        productPlaceholder: "Select a product",
      },
      info: {
        addressLabel: "Address",
        address: "73000, Kherson, vul. Raketna, 110a, Ukraine",
        phoneLabel: "Phones",
        emailLabel: "Email",
        scheduleLabel: "Hours",
        schedule: "Mon – Fri · 09:00 – 18:00",
      },
    },
    footer: {
      tagline: "Sunflower & vegetable oil producer since 2003",
      rights: "All rights reserved.",
      legal: "Legal notice",
      edrpou: "EDRPOU 32125693",
    },
    video: {
      overline: "The factory in motion",
      title: "Discover our craft in motion",
      subtitle:
        "From seed to bottle — step inside EKOBIOTEK: our production lines, our teams and the standards that drive us.",
      watchOnFacebook: "Watch on Facebook",
      unmuteHint: "Tap to unmute",
      playingLabel: "Now playing",
    },
  },

  ua: {
    nav: {
      about: "Про нас",
      products: "Продукти",
      process: "Виробництво",
      quality: "Якість",
      export: "Експорт",
      contact: "Контакти",
      cta: "Замовити пропозицію",
    },
    hero: {
      overline: "З 2003 року · Херсон · Україна",
      title1: "Рідке золото",
      title2: "українських полів",
      subtitle:
        "EKOBIOTEK-UKRAINA вирощує, віджимає та рафінує соняшникову та рослинні олії з безкомпромісною якістю — від насіння до пляшки.",
      cta1: "Наша продукція",
      cta2: "Запит пропозиції",
      stat1: "Років досвіду",
      stat2: "Співробітників",
      stat3: "Експортних ринків",
    },
    about: {
      overline: "Наша історія",
      title: "Український виробник, відданий якості",
      p1: "Заснована у 2003 році в Херсоні, ТОВ \"EKOBIOTEK-UKRAINA\" виробляє сиру та рафіновану соняшникову олію, а також широкий асортимент рослинних олій для харчової, фармацевтичної та промислової галузей.",
      p2: "Наші 90 співробітників продовжують традиції, що сягають корінням у чорноземи України — найродючіші в Європі для вирощування соняшника.",
      pillar1: { t: "Перевірене походження", d: "Соняшник вирощений виключно в Україні, простежуваність кожного зерна." },
      pillar2: { t: "Преміум-рафінування", d: "Багатоступенева обробка для прозорої, нейтральної, стабільної олії." },
      pillar3: { t: "Міжнародний стандарт", d: "Експортна упаковка, відповідність нормам ЄС та Азії." },
    },
    products: {
      overline: "Наш асортимент",
      title: "Чотири олії, один підпис",
      subtitle: "Чисте ремесло — від пресу до вашого столу або виробничої лінії.",
      list: [
        {
          slug: "refined-sunflower-oil",
          name: "Рафінована соняшникова олія",
          tag: "Преміум",
          desc: "Дезодорована, нейтральна, ідеальна для смаження, харчової промисловості та приватної марки.",
          spec: "Кислотність < 0,1% · Точка диму 230°C",
          fullDesc:
            "Наша рафінована соняшникова олія виробляється за багатоступеневим процесом: гідратація, нейтралізація, відбілювання та дезодорація. Результат — ідеально прозора олія нейтрального смаку, стабільна за високих температур, ідеальна для харчової промисловості та приватної марки.",
          applications: [
            "Промислове та домашнє смаження",
            "Виробництво майонезу, соусів, маргарину",
            "Розлив під приватну марку",
            "Консерви та готові страви",
          ],
          specs: [
            { k: "Вільна кислотність", v: "< 0,1% (олеїнова)" },
            { k: "Точка диму", v: "230°C" },
            { k: "Перекисне число", v: "< 2 мекв O2/кг" },
            { k: "Вологість", v: "< 0,1%" },
            { k: "Колір (Lovibond)", v: "≤ 1,5 R" },
            { k: "Термін зберігання", v: "12 місяців" },
          ],
          packaging: [
            "Пляшки PET 1 л / 3 л / 5 л",
            "Бочки 200 л",
            "IBC 1000 л",
            "Флекситанк 20 000 – 24 000 л",
          ],
        },
        {
          slug: "crude-sunflower-oil",
          name: "Сира соняшникова олія",
          tag: "Холодний віджим",
          desc: "Насичений смак насіння, багата на вітамін E, ідеальна для заправок та промислового використання.",
          spec: "Механічний прес · Легка фільтрація",
          fullDesc:
            "Наша сира олія, отримана механічним віджимом та легкою фільтрацією, зберігає характерний аромат соняшникового насіння та природне багатство на вітамін E і фітостероли.",
          applications: [
            "Кулінарні заправки",
            "Сировина для рафінерій",
            "Косметика та догляд за шкірою",
            "Біодизель та промислове використання",
          ],
          specs: [
            { k: "Вільна кислотність", v: "1 – 2%" },
            { k: "Йодне число", v: "118 – 141" },
            { k: "Вітамін E", v: "40 – 60 мг/100г" },
            { k: "Вологість", v: "< 0,2%" },
            { k: "Термін зберігання", v: "6 місяців" },
          ],
          packaging: ["Бочки 200 л", "IBC 1000 л", "Цистерна / флекситанк"],
        },
        {
          slug: "blended-vegetable-oils",
          name: "Купажовані рослинні олії",
          tag: "Під замовлення",
          desc: "Технічні суміші за специфікацією: соняшник, ріпак, соя, кукурудза.",
          spec: "Кастомізація жирних кислот",
          fullDesc:
            "Ми формулюємо індивідуальні суміші рослинних олій: збалансовані пропорції омега-3/6, оптимізована точка диму, персоналізований органолептичний профіль.",
          applications: [
            "Формули професійної кухні",
            "Спортивне харчування",
            "Харчова промисловість",
            "Дитячі продукти (на валідації)",
          ],
          specs: [
            { k: "Базові олії", v: "Соняшник, ріпак, соя, кукурудза" },
            { k: "Профіль жирних кислот", v: "Кастомізований" },
            { k: "Точка диму", v: "200 – 240°C" },
            { k: "Добавки", v: "Вітаміни A/D/E опціонально" },
          ],
          packaging: [
            "Кастомізовані пляшки PET",
            "Бочки 200 л",
            "IBC та флекситанк",
          ],
        },
        {
          slug: "meal-by-products",
          name: "Шроти та побічні продукти",
          tag: "Циркулярність",
          desc: "Білковий шрот для тваринництва, повна валоризація насіння.",
          spec: "32-38% білка",
          fullDesc:
            "Соняшниковий шрот з нашого пресу — преміум-джерело білка для тваринництва: велика рогата худоба, свині, птиця, аквакультура. 100% валоризація насіння відповідно до нашої zero-waste політики.",
          applications: [
            "Корми для ВРХ та молочного тваринництва",
            "Свинарство та птахівництво",
            "Аквакультура",
            "Біогаз та циркулярна енергія",
          ],
          specs: [
            { k: "Сирий протеїн", v: "32 – 38%" },
            { k: "Залишковий жир", v: "1 – 2%" },
            { k: "Сира клітковина", v: "18 – 22%" },
            { k: "Вологість", v: "< 11%" },
          ],
          packaging: [
            "Насипом (вантажівка, залізниця)",
            "Біг-беги 500 – 1000 кг",
            "Мішки 50 кг",
          ],
        },
      ],
      explore: "Технічні дані",
      backToProducts: "← Назад до продуктів",
      applicationsTitle: "Застосування",
      specsTitle: "Технічні характеристики",
      packagingTitle: "Упаковка",
      contactCta: "Запит на цей продукт",
    },
    process: {
      overline: "Від поля до пляшки",
      title: "Чотири етапи, жодного компромісу",
      steps: [
        { n: "01", t: "Збір урожаю", d: "Насіння соняшника з полів Херсонщини, відібране під час жнив." },
        { n: "02", t: "Пресування", d: "Механічний прес та екстракція розчинником для оптимального виходу та чистої олії." },
        { n: "03", t: "Рафінування", d: "Гідратація, нейтралізація, відбілювання та дезодорація — лабораторний контроль на кожному етапі." },
        { n: "04", t: "Розлив", d: "Пляшки PET, бочки 200 л, флекситанк-контейнери для експорту." },
      ],
    },
    quality: {
      overline: "Якість і відповідність",
      title: "Стандарти, що не згинаються",
      subtitle: "Кожна партія тестується. Кожна поставка відстежується. Кожен клієнт заслуговує на однакову ретельність.",
      points: [
        "ISO 22000 — Безпека харчових продуктів",
        "HACCP — Аналіз небезпек та критичних контрольних точок",
        "GMP+ — Належна виробнича практика",
        "Halal & Kosher — На запит",
        "Non-GMO — Сертифіковано",
        "Внутрішній лабораторний контроль",
      ],
    },
    exportSec: {
      overline: "Міжнародна присутність",
      title: "Херсонська олія по всьому світу",
      p:
        "Наша мультимодальна логістика — флекситанки, ISO-бочки, паллетовані пляшки — забезпечує надійні постачання з українських та румунських портів до Європи, Близького Сходу, Північної Африки та Азії.",
      stats: [
        { v: "20+", l: "Країн-партнерів" },
        { v: "50 000Т", l: "Річна потужність" },
        { v: "24/48 год", l: "Відповідь на запит" },
        { v: "100%", l: "Походження Україна" },
      ],
    },
    contact: {
      overline: "Зв'яжіться з нами",
      title: "Маєте проєкт? Об'єм для відвантаження?",
      subtitle: "Наша експортна команда відповідає протягом 24-48 робочих годин французькою, англійською та українською.",
      form: {
        name: "Повне ім'я",
        email: "Робоча електронна пошта",
        phone: "Телефон",
        company: "Компанія",
        product: "Продукт, що цікавить",
        message: "Ваше повідомлення",
        submit: "Надіслати запит",
        sending: "Надсилання...",
        success: "Дякуємо! Ваше повідомлення надіслано.",
        error: "Щось пішло не так. Спробуйте ще раз.",
        productPlaceholder: "Оберіть продукт",
      },
      info: {
        addressLabel: "Адреса",
        address: "73000, м. Херсон, вул. Ракетна, 110а, Україна",
        phoneLabel: "Телефони",
        emailLabel: "Email",
        scheduleLabel: "Графік",
        schedule: "Пн – Пт · 09:00 – 18:00",
      },
    },
    footer: {
      tagline: "Виробник соняшникової та рослинних олій з 2003 року",
      rights: "Усі права захищені.",
      legal: "Юридична інформація",
      edrpou: "ЄДРПОУ 32125693",
    },
    video: {
      overline: "Виробництво в дії",
      title: "Подивіться, як ми працюємо",
      subtitle:
        "Від насіння до пляшки — зазирніть у щоденне життя EKOBIOTEK: наші виробничі лінії, наші команди та стандарти, що нас рухають.",
      watchOnFacebook: "Дивитися на Facebook",
      unmuteHint: "Увімкнути звук",
      playingLabel: "Відтворення",
    },
  },
};

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "ua", label: "UA" },
];
